import axios from 'axios'
import { EventBus } from '@/eventBus'
import { Message } from 'element-ui'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 从环境变量获取 API 地址
  timeout: 5000 // 请求超时时间（毫秒）
})

// 请求拦截器（可在请求前统一处理，如添加 token）
service.interceptors.request.use(
  config => {
    // 如果需要 token，可以在这里添加
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器（统一处理响应数据或错误）
service.interceptors.response.use(
  response => {
    const res = response.data
    const success = res.success ?? (res.code === 200)
    const msg = res.message || res.msg || '请求失败'
    const code = res.code || ''

    // 统一失败判断
    if (!success) {
      Message.error(msg)

      // 401 未授权统一处理
      if (code === 401) {
        EventBus.$emit('show-login-modal')
        return Promise.reject(new Error('登录已过期，请重新登录'))
      }

      return Promise.reject(res)
    }

    // 成功直接返回数据
    return res
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
